import { Camera } from '@ionic-native/camera';
import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { App, DeepLinkConfigToken, IonicApp, IonicModule, UrlSerializer } from 'ionic-angular';
import { ConsectusApp } from './app.component';
import { setupBlockedUrlSerializer } from './url-guard';
import { ReactiveFormsModule } from '@angular/forms'

import { ApplicationAddressPageModule } from '../pages/new-account/bank-new-account/application-address/application-address.module';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Geolocation } from '@ionic-native/geolocation';
import { GoogleMaps, Geocoder } from '@ionic-native/google-maps';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { SecureStorage } from '@ionic-native/secure-storage';
import { Sim } from '@ionic-native/sim';
import { SecureStorageProvider } from '../providers/secure-storage/secure-storage';
import { SettingsProvider } from '../providers/settings/settings';
import { GatewayClientProvider } from '../providers/gateway-client/gateway-client';
import { SavingsAccountsProvider } from '../providers/savings-accounts/savings-accounts';
import { MortgageAccountsProvider } from '../providers/mortgage-accounts/mortgage-accounts';
import { BranchesProvider } from '../providers/branches/branches';
import { FaqProvider } from '../providers/faq/faq';
import { LanguageProvider } from '../providers/language/language';
import { ProductsProvider } from '../providers/products/products';
import { MemberProvider } from '../providers/member/member';
import { MessagesProvider } from '../providers/messages/messages';
import { GoalsProvider } from '../providers/goals/goals';
import { ChequeProvider } from '../providers/cheque/chequeprovider';
import { DirectDebitProvider } from '../providers/direct-debit/direct-debit';
import { SaverProvider } from '../providers/saver/saver';
import { SavingsAnalysisProvider } from '../providers/savings-analysis/savings-analysis';
import { HttpModule } from '@angular/http';
import { IonicStorageModule } from '@ionic/storage';
import { Push } from '@ionic-native/push';
import { Device } from '@ionic-native/device';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MediaCapture } from '@ionic-native/media-capture';
import { File } from '@ionic-native/file';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';

// import { Push } from '@ionic-native/push';
import { FingerprintAIO } from "@ionic-native/fingerprint-aio";
import { GlobalvariablesProvider } from '../providers/globalvariables/globalvariables';
import { HeaderModule } from './../components/header/header.module';
import { CalculatorProvider } from '../providers/calculator/calculator';
import { FCM } from '@ionic-native/fcm';
import { OnboardingProvider } from '../providers/onboarding/onboarding';
import { ContactUsProvider } from '../providers/contact-us/contact-us';
import { Network } from '@ionic-native/network';
import { VideoCameraProvider } from '../providers/video-camera/video-camera';
import { InactiveProvider } from '../providers/inactive/inactive';
import { LocalNotifications } from '@ionic-native/local-notifications';
import { Badge } from '@ionic-native/badge';
import { PaycassoProvider } from '../providers/paycasso/paycasso';
import { DatePipe } from '@angular/common';
import { DatePickerModule } from 'ionic3-datepicker';
import { ProfileProvider } from '../providers/profile/profile';
import { InactiveServiceProvider } from '../providers/inactive-service/inactive-service';

export class ConsectusErrorHandler implements ErrorHandler {
  handleError(error) {
    // 
    // 
    // do something with the exception
  }
}

@NgModule({
  declarations: [
    ConsectusApp,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    ApplicationAddressPageModule,
    HttpModule,
    IonicModule.forRoot(ConsectusApp, {
      statusbarPadding: false,
      mode: 'ios',
      scrollPadding: false,
      scrollAssist: true,
      autoFocusAssist: false,
      menuType: "overlay"
    }),
    HeaderModule,
    NgIdleKeepaliveModule,
    IonicStorageModule.forRoot(),
    DatePickerModule,

  ],
  bootstrap: [IonicApp],
  entryComponents: [
    ConsectusApp,

  ],
  providers: [
    DatePipe,
    StatusBar,
    Geolocation,
    GoogleMaps,
    Geocoder,
    InAppBrowser,
    Sim,
    Device,
    FCM,
    Badge,
    SecureStorage,
    SecureStorageProvider,
    SettingsProvider,
    GatewayClientProvider,
    SavingsAccountsProvider,
    MortgageAccountsProvider,
    LanguageProvider,
    GatewayClientProvider,
    SavingsAccountsProvider,
    MortgageAccountsProvider,
    ProductsProvider,
    MemberProvider,
    MessagesProvider,
    GoalsProvider,
    SavingsAnalysisProvider,
    FaqProvider,
    BranchesProvider,
    FingerprintAIO,
    SplashScreen,
    GlobalvariablesProvider,
    ChequeProvider,
    DirectDebitProvider,
    SaverProvider,
    Camera,
    Push,
    FileTransfer,
    FileTransferObject,
    Network,
    { provide: ErrorHandler, useClass: ConsectusErrorHandler },
    CalculatorProvider,
    OnboardingProvider,
    ContactUsProvider,
    VideoCameraProvider,
    MediaCapture,
    File,
    InactiveProvider,
    LocalNotifications,
    PaycassoProvider,
    ProfileProvider,
    InactiveServiceProvider,
    // Overrides IonicModule's UrlSerializer so the pages in URL_BLOCKED_PAGES
    // cannot be reached by typing their deep-link segment.
    { provide: UrlSerializer, useFactory: setupBlockedUrlSerializer, deps: [App, DeepLinkConfigToken] },
  ]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts